import { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { nativeBridgeClient } from './nativeBridgeClient';
import { useRegisterVoipTokenMutation } from '../services/VoipService';
import { getLoggedInUser } from '../selectors/userSelectors';

export default function VoipNativeBridgeListener() {
  const currentUser = useSelector(getLoggedInUser);
  const [registerVoipToken] = useRegisterVoipTokenMutation();

  const persistVoipToken = useCallback((token) => {
    if (!token) return;

    const deviceUuid = localStorage.getItem('device_uuid');
    const extensionUuid = currentUser?.extensions?.[0]?.uuid;
    const lastToken = localStorage.getItem('voip_token');

    // 1) Short-circuit FIRST
    if (lastToken === token) {
      console.log('=== VoIP token unchanged — skip ==='); // eslint-disable-line no-console
      return;
    }

    // 2) Store updated value
    localStorage.setItem('voip_token', token);

    // 3) Safety
    if (!deviceUuid || !extensionUuid) {
      console.log('=== VoIP token ignored (missing extension/device) ==='); // eslint-disable-line no-console
      return;
    }

    // 4) Register server-side
    registerVoipToken({
      deviceUuid,
      extensionUuid,
      voipToken: token,
    });
  }, [currentUser, registerVoipToken]);

  useEffect(() => {
    const handler = (raw) => {
      let msg;
      try {
        msg = typeof raw.data === 'string' ? JSON.parse(raw.data) : raw.data;
      } catch (_) { return; }

      const { type, payload } = msg || {};
      if (!type) return;

      switch (type) {
        case 'voipIncomingCall':
          nativeBridgeClient._emitFromNative('incomingCall', payload);
          break;

        case 'voipCallConnected':
          nativeBridgeClient._emitFromNative('callConnected', payload);
          break;

        case 'voipCallEnded':
          nativeBridgeClient._emitFromNative('callEnded', payload);
          break;

        case 'voipMediaReady':
          nativeBridgeClient._emitFromNative('nativeMedia', payload);
          break;

        case 'voipOutgoingCall':
          nativeBridgeClient._emitFromNative('outgoingCall', payload);
          break;

        case 'voipMuteToggled':
          nativeBridgeClient._emitFromNative('muteToggled', payload);
          break;

        case 'voipHoldToggled':
          nativeBridgeClient._emitFromNative('holdToggled', payload);
          break;

        case 'voipTokenUpdated':
          persistVoipToken(payload?.token);
          break;
        default:
          break;
      }
    };

    document.addEventListener('message', handler);
    window.addEventListener('message', handler);

    return () => {
      document.removeEventListener('message', handler);
      window.removeEventListener('message', handler);
    };
  }, [persistVoipToken]);

  return null;
}

// import { useEffect } from 'react';
// import { nativeBridgeClient } from './nativeBridgeClient';
// import { useRegisterVoipTokenMutation } from '../services/VoipService';

// export default function VoipNativeBridgeListener() {
//   useEffect(() => {
//     const handler = (raw) => {
//       let msg;
//       try {
//         msg = typeof raw.data === 'string' ? JSON.parse(raw.data) : raw.data;
//       } catch (_) { return; }

//       if (!msg?.type) return;

//       switch (msg.type) {
//         case 'voipIncomingCall':
//           nativeBridgeClient._emitFromNative('incomingCall', msg.payload);
//           break;
//         case 'voipCallConnected':
//           nativeBridgeClient._emitFromNative('callConnected', msg.payload);
//           break;
//         case 'voipCallEnded':
//           nativeBridgeClient._emitFromNative('callEnded', msg.payload);
//           break;
//         case 'voipMediaReady':
//           nativeBridgeClient._emitFromNative('nativeMedia', msg.payload);
//           break;
//         case 'voipOutgoingCall':
//           nativeBridgeClient._emitFromNative('outgoingCall', msg.payload);
//           break;
//         case 'voipMuteToggled':
//           nativeBridgeClient._emitFromNative('muteToggled', msg.payload);
//           break;
//         case 'voipHoldToggled':
//           nativeBridgeClient._emitFromNative('holdToggled', msg.payload);
//           break;
//         case 'voipTokenUpdated':
//           const voipToken = msg.payload?.token;
//           const extensionUuid = currentUser?.extensions?.[0]?.uuid;
//           const deviceUuid = localStorage.getItem("device_uuid");
//           const [registerVoipToken] = useRegisterVoipTokenMutation();

//           if (voipToken && extensionUuid && deviceUuid) {
//             registerVoipToken({
//               deviceUuid,
//               extensionUuid,
//               voipToken,
//             });
//           }
//           break;
//         default:
//           break;
//       }
//     };

//     document.addEventListener('message', handler);
//     window.addEventListener('message', handler);

//     return () => {
//       document.removeEventListener('message', handler);
//       window.removeEventListener('message', handler);
//     };
//   }, []);

//   return null;
// }
